import { NgModule } from '@angular/core';
import { DuplicateResolutionRadioGroupComponent } from './duplicate-resolution-radio-group.component';
import {  MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        MatRadioModule,
        FormsModule,
    ],
    declarations: [DuplicateResolutionRadioGroupComponent],
    exports: [
        DuplicateResolutionRadioGroupComponent,
        MatRadioModule,
        FormsModule,
    ],
})
export class DuplicateResolutionRadioGroupModule {}
